<template>
  <div>
    <div v-if="tableData.length">
      <div class="setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableData"> 
          <template slot-scope="{ row }" slot="orderPolicyNo">
            <div class="order-policy-no">
              <a class="nomber" @click="$refs.orderDetail.open({orgName:row.organizationName, groupName:row.groupName, salesmanName:row.agentName, ...row})">
                {{ row.orderNo || '-' }}
                <span v-if="!row.orderNo" class="line">-</span>
              </a>
              / 
              <a class="nomber" @click="openPolicyDetail(row)">
                {{ row.policyNo }}
                <span v-if="!row.policyNo" class="line">-</span>
              </a>
            </div>
          </template>

          <template slot-scope="{ row }" slot="productName">
            <div class="order-policy-no">
              <a class="nomber" :href="row.insureUrl" target="_blank" v-if="row.insureUrl">
                {{ row.productName || '-' }}
              </a>
              <span v-else>
                {{ row.productName || '-' }}
              </span>
            </div>
          </template>
        </Table>
      </div>

      <div class="pageBox">
        <Page
          :total="total"
          :current="pageNo"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center;"
        />
      </div>
    </div>
    
    <no-data v-if="!tableData.length"></no-data>

    <!-- 订单详情 -->
    <order-detail ref="orderDetail"></order-detail>

    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef"></policyDetail>

    <!-- 线上保单详情  -->
    <detailModal ref="detailModal"></detailModal>

  </div>
</template>

<script>
import filter from "@/api/filter";
import orderDetail from '@/components/commons/orderDetail';
import detailModal from "../../../../orderManage/insuredOrder/components/detailModal";
import policyDetail from "../../../../orderManage/insuredOrder/components/policyDetail";

export default {  
  name:'detailInsureInfo',
  props:['id','agentId'],
  components:{
    orderDetail,
    detailModal,
    policyDetail
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      columns: [
        {
          title: "序号",
          type: "index",
          align: "center",
          minWidth: 70,
        },
        {
          title: "订单号/保单号",
          align: "center",
          width:420,
          slot:"orderPolicyNo"
        },
        {
          title: "保单状态",
          minWidth: 100,
          align: "center",
          render(h, params) {
            if(params.row.status == 1){
              return <span>已承保</span>;
            }else if(params.row.status == 0) {
              return <span>已终止</span>;
            }else if(params.row.status == 2) {
              return <span>续保</span>;
            }else if(params.row.status == -1) {
              return <span>已退保</span>;
            }else{
              return <span>-</span>;
            }            
          }
        },
        {
          title: "投/被保人",
          minWidth: 200,
          align: "center",
          render(h, params) {
            return <span>{params.row.holderName||'-'}/{params.row.insuranceName||'-'}</span>;
          }
        },
        {
          title: "产品名称",
          width:350,
          align: "center",
          slot:"productName"
        },
        {
          title: "保险公司",
          minWidth: 140,
          key: "companyName",
          align: "center",
        },
        {
          title: "保费（元）",
          minWidth: 140,
          key: "fee",
          align: "center",
        },
        {
          title: "保障期",
          minWidth: 110,
          key: "guaranteeLimitValue",
          align: "center",
        },
        {
          title: "交费期",
          minWidth: 120,
          key: "payLimitValue",
          align: "center",
        },
        {
          title: "创建时间",
          align: "center",
          width: 160,
          render(h, params) {
            const result = params.row.createTime;
            return <span>{filter.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
          }
        }
      ],
    };
  },

  created(){
    this.getInsureList();
  },

  methods: {
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/policy/list",
        type: "POST",
        data: {
          agentId:this.agentId,
          customerId:this.id,
          pageSize:this.pageSize,
          pageNo:this.pageNo
        },
      }).then((res) => {
        this.$root.$children[0].isShowLoading = false;
        this.tableData = res.data;
        this.total = res.total;
      }).catch(() => {
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 保单详情
    openPolicyDetail(row) {
      if(row.sourceType == 2){
        this.$refs["policyDetailRef"].open({orgName:row.organizationName, groupName:row.groupName, salesmanName:row.agentName, ...row});
      }else {
        this.$refs["detailModal"].open({orgName:row.organizationName, groupName:row.groupName, salesmanName:row.agentName, ...row});
      }
    },

    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getInsureList();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .setTable .ivu-table th .ivu-table-cell {
  font-size: 15px;
  font-weight: bold;
  color: #272933;
}

.order-policy-no {  
  .nomber {
    color: #236DFF;
    border-bottom: 1px solid #236DFF;
    .line {
      color: #000;      
      border-bottom: 1px solid #fff;
    }
  }
}

.pageBox {
  margin-top: 20px;
}
</style>